import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

export interface CourseLibrarySearchStateType {
  isSearchOpen: boolean;
  isNewModuleOpen: boolean;
}
export const courseLibraryAdapter = createEntityAdapter();

const initialState: CourseLibrarySearchStateType =
  courseLibraryAdapter.getInitialState({
    isSearchOpen: false,
    isNewModuleOpen: false,
  });

const courseLibrarySearchSlice = createSlice({
  name: 'courseLibrary',
  initialState,
  reducers: {
    openSearch: (state) => {
      state.isSearchOpen = true;
    },
    closeSearch: (state) => {
      state.isSearchOpen = false;
    },
    openNewModule: (state) => {
      state.isNewModuleOpen = true;
    },
    closeNewModule: (state) => {
      state.isNewModuleOpen = false;
    },
  },
});

export const { name, actions, reducer } = courseLibrarySearchSlice;
